'use client';

import { createContext, ReactNode, useContext, useState } from 'react';
import { I18nLanguageCode, I18nLocale, LANGUAGE_CODE, LOCALE } from 'utils';

type Settings = Record<
  'url' | 'fullUrl' | 'host' | 'locale' | 'languageCode',
  string
>;

export const SettingsContext = createContext<{
  locale: I18nLocale;
  languageCode: I18nLanguageCode;
  url: string;
  fullUrl: string;
  host: string;
}>({
  locale: LOCALE.PL,
  languageCode: LANGUAGE_CODE.PL,
  url: '/',
  host: '/',
  fullUrl: '/',
});

export const SettingsProvider = ({
  children,
  value: initialValue,
}: {
  children: ReactNode;
  value?: Settings;
}) => {
  const [locale] = useState<I18nLocale>(
    (initialValue?.locale as I18nLocale) || LOCALE.PL
  );
  const [languageCode] = useState<I18nLanguageCode>(
    (initialValue?.languageCode as I18nLanguageCode) || LANGUAGE_CODE.PL
  );
  const [url] = useState<string>(initialValue?.url || '/');
  const [host] = useState<string>(initialValue?.host || '/');
  const [fullUrl] = useState<string>(initialValue?.fullUrl || '/');

  return (
    <SettingsContext.Provider
      value={{ locale, languageCode, url, host, fullUrl }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  return useContext(SettingsContext);
};
